// src/components/managesubs/SubscriptionInfo.js
import React, { useState } from "react";
import TransactionPopup from "../common/TransactionPopup";

const SubscriptionInfo = ({ plan, status, daysLeft, maxCredits, barValue,availableCredits }) => {
  const [showPopup, setShowPopup] = useState(false);
  
  // console.log("SubscriptionInfo rendering with props:", { plan, status, daysLeft, maxCredits, barValue });

  const handleManageBillingClick = () => {
    // Redirect to Stripe billing portal
    window.open('https://billing.stripe.com/p/login/3cI6oH7Fx1CScsT6Y15sA00', '_blank');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-4xl font-bold text-gray-900">Subscription Details</h2>
          <button
            onClick={handleManageBillingClick}
            className="bg-blue-600 text-white font-medium py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-200"
          >
            Manage Billing Info
          </button>
        </div>
        <hr className="border-t-4 border-gray-300 my-4 mx-auto w-full" />
        <div className="mb-4">
          <p className="text-lg">
            Current Plan:{" "}
            <span className="ml-4" />
            <span
              className={`inline-block px-4 py-2 rounded-3xl ${
                plan === "Free Plan"
                  ? "bg-gray-300"
                  : plan === "Pro Plan"
                  ? "bg-gradient-to-r from-gray-400 to-gray-600 animate-shiny-metal"
                  : plan === "Premium Plan"
                  ? "bg-gradient-to-r from-yellow-400 to-yellow-600 animate-liquid-shine"
                  : "bg-gray-300"
              }`}
              style={{ color: "#000000" }}
            >
              {plan || "No Plan Selected"}
            </span>
          </p>
        </div>
        <hr className="border-t-2 border-gray-300 my-4 mx-auto max-w-[80%]" />
        <div className="mb-4">
          <p className="text-lg">
            Subscription Status:{" "}
            <span className="ml-4" />
            <span
              className={`inline-block px-4 py-2 rounded-3xl ${
                status ? "bg-green-300" : "bg-gray-300"
              }`}
              style={{ color: "#000000" }}
            >
              {status !== null ? (status ? "Active" : "Not Active") : "Unknown"}
            </span>
          </p>
        </div>
        <hr className="border-t-2 border-gray-300 my-4 mx-auto max-w-[80%]" />
        <div className="mb-4">
          <p className="text-lg font-medium">Credit Usage: { availableCredits }</p>
          <p className="text-sm text-gray-600">Any unused credit will roll over to the next month</p>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
            <div
              className="bg-blue-600 h-2.5 rounded-full"
              style={{ width: `${barValue}%` }}
            ></div>
          </div>
          <p className="text-sm text-gray-600">
            {status !== null
              ? status
                ? `Next recharge in ${daysLeft} Days`
                : `${maxCredits} Used (Rest in 24 Days)`
              : "N/A"}
          </p>
        </div>
        <style>
          {`
            /* Custom colors for solid backgrounds */
            .silver-400 { background-color: #c0c0c0; } /* Kept for reference */
            .gray-400 { background-color: #a3a3a3; }
            .gray-600 { background-color: #4b5563; }
            .green-300 { background-color: #86efac; }
            .green-500 { background-color: #22c55e; }
            .red-300 { background-color: #fca5a5; }
            .red-500 { background-color: #ef4444; }
            .gray-300 { background-color: #d3d3d3; }
            .gray-500 { background-color: #a9a9a9; }
            .yellow-400 { background-color: #facc15; }
            .yellow-600 { background-color: #ca8a04; }

            /* Shiny metal animation for Pro Plan */
            .animate-shiny-metal {
              background-size: 200% 100%;
              animation: shiny-metal 3s ease-in-out infinite;
            }
            @keyframes shiny-metal {
              0% { background-position: 0% 50%; }
              50% { background-position: 100% 50%; }
              100% { background-position: 0% 50%; }
            }

            /* Liquid shine animation for Premium Plan */
            .animate-liquid-shine {
              background-size: 200% 200%;
              animation: liquid-shine 5s ease-in-out infinite;
            }
            @keyframes liquid-shine {
              0% { background-position: 0% 0%; }
              25% { background-position: 50% 25%; }
              50% { background-position: 100% 50%; }
              75% { background-position: 50% 75%; }
              100% { background-position: 0% 0%; }
            }
          `}
        </style>
      </div>
      
      {/* Transaction Popup */}
      {showPopup && (
        <TransactionPopup
          message="Transaction complete"
          duration={10000}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default SubscriptionInfo;